var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"section2"}},[_c('tUnis',{attrs:{"titles":_vm.p18s2titles,"unis":_vm.p18s2items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }